export default "__VITE_ASSET__60xq9p6c__"